package com.exura.features.plandefinition.domain.model.series

import com.exura.features.plandefinition.domain.model.element.FloatingElement
import dev.gitlive.firebase.firestore.CollectionReference
import kotlin.math.ceil

data class SimpleFloatingSeries(
    override val firebaseDocId: String? = null,
    override val firebaseDocPrefix: CollectionReference? = null,
    override val title: String,
    override val description: String,
    override val elements: List<FloatingElement> = emptyList(),
    val instruction: String,
    val durationInMinutes: Int,
    val deadline: Int? = null,
    val exactTime: HourOfDay? = null,
    override val imageUrl: String? = null,
) : BaseSeries<FloatingElement> {
    override val seriesSpawnType: SeriesSpawnType = SeriesType.SIMPLE_FLOATING.spawnType
    override val relativeDay: Int? = deadline

    override fun spawnElements(): List<FloatingElement> {
        return listOf(
            FloatingElement(
                title = instruction,
                instruction = instruction,
                durationInMinutes = durationInMinutes,
                deadline = deadline,
                exactTime = exactTime,
                imageUrl = imageUrl
            )
        )
    }

    override fun durationInDays(): Int = ceil(durationInMinutes.toFloat() / 60 / 24).toInt()
}
